import { Typography } from "@mui/material";
import LaunchIcon from "@mui/icons-material/Launch";
import ImageWithFooterCardStyles from "./ImageWithFooterCardSource.styles";

const ImageWithFooterCardSource = (props) => {
  const { image, href, source } = props;
  const classes = ImageWithFooterCardStyles();

  return (
    <a
      href={href.route}
      rel={href.target === "_blank" ? "noopener noreferrer" : undefined}
      target={href.target}
      className={classes.linkContainer}
    >
      <div className={classes.container}>
        <div className={classes.imageContainer}>
          <img {...image} />
        </div>
        <div className={classes.footer}>
          <Typography target="{href.target}" variant="body_strong_black">{href.title}</Typography>

          <div className={classes.source}>
            <LaunchIcon className={classes.launchIcon} />
            <Typography variant="body_gray" noWrap className={classes.sourceText}>
              {source}
            </Typography>
          </div>
        </div>
      </div>
    </a>
  );
};

export default ImageWithFooterCardSource;
